import React, { Fragment, useEffect, useState } from 'react';
import { generateSlideName } from 'components/pages/livefeed/Editor/EditorContainer/common/commonFn'
import Slider from "react-slick";
import LivefeedPreview from '../../EditorContainer/LivefeedPreview'
import _ from 'lodash'

const SnapshotSlidesCarousel = (props) => {
    const { dispatch, nodeMap, sensorMap, chosenTemplate, setChosenLayout, currentSlideTypeState, slideCurrentIndex } = props
    const [snapshotSlides, setSnapshotSlides] = useState([])
    const [chosenLayoutIndex, setChosenLayoutIndex] = useState(0)
    const [uniqueId, setUniqueId] = useState(_.uniqueId('snapshotCarousel_')
    )
    const settings = {
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: false,
        fade: true,
        speed: 600,
        pauseOnHover: false,
        swipe: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        afterChange: current => {
            setChosenLayoutIndex(current)
        }
    };

    useEffect(() => {
        let arr = []
        for (let i = 0; i < chosenTemplate.data.livefeedSlides.length; ++i) {
            if (chosenTemplate.data.livefeedSlides[i].slideType === currentSlideTypeState) {
                arr.push(chosenTemplate.data.livefeedSlides[i])
            }
        }
        for (let i = 0; i < arr.length; ++i) {
            arr[i].id = i
        }

        setSnapshotSlides(arr)
        setUniqueId(_.uniqueId('snapshotCarousel_'))
    }, [chosenTemplate.data.livefeedSlides, currentSlideTypeState, slideCurrentIndex])


    useEffect(() => {
        setChosenLayout(snapshotSlides[chosenLayoutIndex])
    }, [chosenLayoutIndex, setChosenLayout, snapshotSlides, slideCurrentIndex])

    return (
        <Fragment >
            {snapshotSlides.length > 0 ?
                <p>
                    All styles on chosen slide layout:&nbsp;
                    {generateSlideName(snapshotSlides, snapshotSlides[chosenLayoutIndex])}will be applied
                </p>
                :
                <p>There is no layout slide available for this slide  </p>
            }
            <Slider
                key={uniqueId}
                {...settings}>
                {snapshotSlides.length > 0 && snapshotSlides.map((_, index) => {
                    return (
                        <div key={index} className="selected-slide">
                            <LivefeedPreview
                                scaleMode={true}
                                dispatch={dispatch}
                                livefeedSlides={snapshotSlides}
                                slideCurrentIndex={index}
                                nodeMap={nodeMap}
                                stepNumberState={0}
                                editorView={false}
                                sensorMap={sensorMap}
                                mapConfigMode={'user_input'}
                                focusMapApiInput={(e) => { e.stopPropagation() }}
                                handleOpenLocationModal={(e) => { e.stopPropagation() }}
                            />
                        </div>
                    )
                })}
            </Slider>
        </Fragment>
    );
}


export default SnapshotSlidesCarousel;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/TopMenuContainer/ChooseLayout/SnapshotSlidesCarousel.jsx